import { ReactComponent as Transition } from "../../../assets/icons/transitions.svg";

export const iconMap = {
  transitions: Transition,
};
export type IconName = keyof typeof iconMap;
